import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, FormGroup, FormFeedback, Input, Form, Label} from 'reactstrap'
import PropTypes from 'prop-types'
import CreatableSelect from '../Wps/CreatableSelect'
import {createBaseMaterialMutation} from './mutations'
import {graphql, withApollo} from 'react-apollo'
import gql from 'graphql-tag'
import {WpsStandardizationsAndMaterialsFetch} from '../Wps/mutations'

const BaseMaterialStandarizationsFetch = gql`
  query BaseMaterialStandarizationsQuery($only_uniq_standardization: Boolean = true) {
    base_materials(only_uniq_standardization: $only_uniq_standardization) {
      standardization
    }
  }
`

class BaseMaterialModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      validation_errors: {},
      standardization_dict: [],
      standardization: {name: 'CUSTOM'}
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    standardizationDict: PropTypes.array,
    createBaseMaterialMutation: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    disableUpdateStore: PropTypes.bool
  }

  componentWillMount() {
    if (!this.props.standardizationDict) {
      this.fetchBaseMaterialStandarizations()
    }
  }

  fetchBaseMaterialStandarizations() {
    this.props.client.query({
      query: BaseMaterialStandarizationsFetch,
      fetchPolicy: 'network-only',
    }).then(({data: { base_materials }}) => {
      this.setState({standardization_dict: base_materials.map(o => ({name: o.standardization}))})
    })
  }

  handleSubmit(event) {
    event.stopPropagation()
    event.preventDefault()
    if (!this.state.standardization) {
      return this.setState({validation_errors: {standardization: 'must exist'}})
    }

    const form_elements = event.target.elements
    this.props.createBaseMaterialMutation({
      variables: {
        designation_name: form_elements.designation_name.value,
        group: form_elements.group.value,
        standard: form_elements.standard.value,
        standardization: this.state.standardization && this.state.standardization.name
      },
      update: (store, {data: {createBaseMaterial}}) => {
        if (!this.props.disableUpdateStore && !createBaseMaterial.errors) {
          const data = store.readQuery({query: WpsStandardizationsAndMaterialsFetch})
          data.base_materials.splice(0, 0, createBaseMaterial.base_material)
          store.writeQuery({
            query: WpsStandardizationsAndMaterialsFetch,
            data,
          })
        }
      },
    }).then(({data: {createBaseMaterial}}) => {
      if (createBaseMaterial.errors) {
        this.setState({validation_errors: JSON.parse(createBaseMaterial.errors)})
      } else {
        this.props.afterSubmit(createBaseMaterial.base_material)
      }
    })
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>Add new Base material</ModalHeader>
        <ModalBody>
          <Form id="base-material-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
            <FormGroup>
              <CreatableSelect
                label="Standardization"
                id="standardization-base-material-form"
                valueKey="name"
                placeholder="Select or type..."
                options={this.props.standardizationDict || this.state.standardization_dict}
                value={this.state.standardization}
                multi={false}
                creatable={true}
                valueChangeFunction={val => {
                  this.setState({standardization: val})
                }}
              />
              <FormFeedback>{this.state.validation_errors.standardization}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="designation-name-base-material-form">Designation name</Label>
              <Input type="text" name="designation_name" id="designation-name-base-material-form" required/>
              <FormFeedback>{this.state.validation_errors.designation_name}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="group-base-material-form">Group</Label>
              <Input type="text" name="group" id="group-base-material-form"/>
              <FormFeedback>{this.state.validation_errors.group}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="standard-base-material-form">Standard</Label>
              <Input type="text" name="standard" id="standard-base-material-form"/>
              <FormFeedback>{this.state.validation_errors.standard}</FormFeedback>
            </FormGroup>

            <hr/>
            <Button id="cancel-base-material-form-btn" className="float-right" color="danger"
              onClick={this.props.onCancel}>Cancel</Button>
            <Button id="save-base-material-form-btn" className="float-right" color="primary" type="submit">Save</Button>
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}

const BaseMaterialModalWithMutations = graphql(createBaseMaterialMutation, {name: 'createBaseMaterialMutation'})(BaseMaterialModal)

export default withApollo(BaseMaterialModalWithMutations)



// WEBPACK FOOTER //
// ./src/components/Dictionary/BaseMaterialModal.js